/* tslint:disable */
/* eslint-disable */
/**
 * PokerWise Backoffice Tenant Management
 * API for managing PokerWise Tenants.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TenantsPostRequestEnabledGameTypesEnum = {
    TexasHoldem: 'TexasHoldem',
    Omaha: 'Omaha'
};
